import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { RelativeItem } from '../data';

interface Props {
  list: RelativeItem[];
  current: string;
}

function RelativeTab({ list, current }: Props) {
  const navigate = useNavigate();
  return (
    <Container>
      <Title>관련물건번호</Title>
      {list.map((item) => {
        const cleanUnitno = item.unitno.replace(/[()]/g, '');
        const isActive = current
          ? current === item.unitno
          : item.unitno.trim() === '(1)';

        return (
          <Tab
            key={item.iidx}
            $active={isActive}
            onClick={() => navigate(`/auction/detail/${item.iidx}`)}
          >
            <span>{cleanUnitno}</span>
            <span className="sale">{item.bid.includes('매각') && '매각'}</span>
            <span>{!item.bid.includes('매각') && item.bid.trim()}</span>
          </Tab>
        );
      })}
    </Container>
  );
}

export default RelativeTab;

const Container = styled.div`
  display: flex;
  padding: 0 16px;
  align-items: center;
  align-self: stretch;
  background: #fff;
  overflow-x: auto;
  width: 100%;
`;

const Title = styled.div`
  display: flex;
  padding: 8px 16px 8px 0;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #e5e8ea;

  color: #222;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Tab = styled.div<{ $active?: boolean }>`
  display: flex;
  gap: 2px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #e5e8ea;
  flex-shrink: 0;

  color: ${({ $active }) => ($active ? '#008AFF' : '#616161')};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;

  ${({ $active }) =>
    $active &&
    `
    background: #F0F8FF;
  `}

  .sale {
    color: #f04452;
  }

  &:last-child {
    border-right: none;
  }
`;
